// extracted by mini-css-extract-plugin
export default {"delete":"theme_delete__OWvum"};